import script from "./ProjectPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectPreview.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCarousel,QCarouselSlide});
